var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoDeserts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.50044C14 5.88544 11.996 3.69344 9.32201 3.13944C9.80901 2.18644 9.04501 0.974439 7.97001 1.00044C6.89001 0.973439 6.12401 2.19844 6.62501 3.15144C3.97801 3.72344 1.99901 5.90144 1.99901 8.50044C1.98501 9.29844 2.38701 10.0344 3.05401 10.4474L4.10001 15.0004H11.897L12.942 10.4504C13.607 10.0394 14.029 9.29944 13.998 8.50044H14ZM7.97101 2.00044C8.62501 2.00444 8.62501 2.99644 7.97101 3.00044C7.31701 2.99644 7.31801 2.00444 7.97101 2.00044ZM11.102 14.0004H4.89801L4.16201 10.7994C4.94301 10.8894 5.71601 10.5174 6.17001 9.96644C7.00501 11.0794 8.99901 11.0794 9.83401 9.96644C10.287 10.5154 11.057 10.8864 11.836 10.7994L11.1 13.9994L11.102 14.0004ZM11.668 9.81644C10.933 9.81644 10.335 9.26644 10.335 8.59144H9.33501C9.30501 10.2004 6.70001 10.1994 6.67101 8.59144H5.67101C5.64301 10.1984 3.03401 10.2004 3.00601 8.59144C2.93201 6.07544 5.21501 3.99744 8.00001 3.99944C10.757 3.99944 13 6.01844 13 8.49944C13.051 9.20644 12.44 9.81844 11.668 9.81544V9.81644Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDeserts);
export default __webpack_public_path__ + "static/media/ico_deserts.8a706e2c2353a834780731b8845e5a7c.svg";
export { ForwardRef as ReactComponent };